import { render, staticRenderFns } from "./AdminSupportStaffModalRoot.vue?vue&type=template&id=7fdb21bf&scoped=true"
import script from "./AdminSupportStaffModalRoot.vue?vue&type=script&lang=js"
export * from "./AdminSupportStaffModalRoot.vue?vue&type=script&lang=js"
import style0 from "./AdminSupportStaffModalRoot.vue?vue&type=style&index=0&id=7fdb21bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb21bf",
  null
  
)

export default component.exports